import React from "react";
import AboutInfo from "./AboutInfo";
import History from "./History";
// import Services from "./Services";
// import Counter from "./Counter";
// import Progress from "./Progress";
// import Team from "./Team";
import BoardOfDirectory from "./BoardOfDirectory";
import KeyManagement from "./KeyManagement";
import WhoToday from "./WhoToday";
// import ChairmanMessage from "./ChairmanMessage";

const About = () => {
  return (
    <div>
      <AboutInfo />
      <History />
      <WhoToday />
      <BoardOfDirectory />
      <KeyManagement />
      {/* <Services /> */}
      {/* <Counter /> */}
      {/* <Progress /> */}
      {/* <Team /> */}
      {/* <ChairmanMessage /> */}
    </div>
  );
};

export default About;
